var moduleMap = {
	".": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_pnpm_yonyou_yon-extension_1_2_55_react_16_14_0_node_modules_yonyou_yon-e-6f2d38"), __webpack_require__.e("vendors-node_modules_pnpm_iuap-sandbox-modal_1_0_79_nuhreje45bcbvogj7hqifot2vy_node_modules_i-8914ed"), __webpack_require__.e("src_utils_hocWithBaseElementWrap_index_js-src_utils_index_js-package_json-webpack_container_r-d83dba"), __webpack_require__.e("src_components_DatePicker_index_js-src_components_DateRangePicker_index_js-src_components_Dat-23a9f5"), __webpack_require__.e("src_components_CollapsePanel_CollapsePanel_js-src_components_TimeZone_TimeZone_js-webpack_con-56a0f8"), __webpack_require__.e("src_index_ts-webpack_container_remote_tns3nd_react-draggable-webpack_container_remote_tns3nd_-0cc1f0")]).then(() => (() => ((__webpack_require__(76607)))));
	},
	"./designer": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_pnpm_css-loader_6_10_0_webpack_5_90_3_node_modules_css-loader_dist_runti-3d9502"), __webpack_require__.e("src_utils_hocWithBaseElementWrap_index_js-src_utils_index_js-package_json-webpack_container_r-d83dba"), __webpack_require__.e("src_components_CollapsePanel_CollapsePanel_js-src_components_TimeZone_TimeZone_js-webpack_con-56a0f8"), __webpack_require__.e("src_designer_ts")]).then(() => (() => ((__webpack_require__(63994)))));
	},
	"./formatter": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_pnpm_yonyou_yon-extension_1_2_55_react_16_14_0_node_modules_yonyou_yon-e-6f2d38"), __webpack_require__.e("src_utils_hocWithBaseElementWrap_index_js-src_utils_index_js-package_json-webpack_container_r-d83dba"), __webpack_require__.e("src_components_DatePicker_index_js-src_components_DateRangePicker_index_js-src_components_Dat-23a9f5"), __webpack_require__.e("src_formatter_ts")]).then(() => (() => ((__webpack_require__(55701)))));
	},
	"./icon": () => {
		return __webpack_require__.e("src_assets_icons_index_js").then(() => (() => ((__webpack_require__(23302)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});